import { h } from 'preact'
import ErrorMessage from './ErrorMessage'
import Loader from './Loader'
import Reference from './Reference'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const References = (props) => {

  if (props.error) {
    return <ErrorMessage type="posts-error" />
  }

  if (!props.loading && props.references.length === 0) {
    return <ErrorMessage type="no-results" />
  }

  return (
    <div className="c-references">

      <div className="c-references__row">
        {
          props.references.map((reference) => {
            return <Reference reference={reference} key={reference.id} language={props.language} />
          })
        }
      </div>

      { props.loading ? (
        <Loader />
      ) : null }

    </div>
  )
}

export default References



// WEBPACK FOOTER //
// ./src/js/references/components/References.js